import { render } from "./ExpenseCategoryPage.vue?vue&type=template&id=6f5a3132&scoped=true&ts=true"
import script from "./ExpenseCategoryPage.vue?vue&type=script&lang=ts"
export * from "./ExpenseCategoryPage.vue?vue&type=script&lang=ts"

import "./ExpenseCategoryPage.vue?vue&type=style&index=0&id=6f5a3132&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5a3132"]])

export default __exports__